import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-page-header-actions',
	templateUrl: 'page-header-actions.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class PageHeaderActionsComponent {}
